<template>
    <jt-form
        :alertType="alert.type"
        :alertShow="alert.show"
        :alertMessage="alert.message"
        v-on:create="create()"
        v-on:closeAlert="closeAlert()"
        v-on:clear="clear()"
        title="Novo Grupo"
    >
        <div class="form-row">
            <div class="col-md-6">
                <b-form-group
                    label="Descrição (Nome do grupo)"
                >
                    <b-form-input
                        type="text"
                        placeholder="Descrição do grupo"
                        v-model="form.descricao"
                        size="sm"
                    />
                    <small v-if="!$v.form.descricao.required" >Campo requerido</small>
                    <small v-if="!$v.form.descricao.minLength" >A descrição esta muito curta.</small>
                </b-form-group>
            </div>

            <div class="col-md-6">
                <b-form-group
                    label="Ativo"
                >
                    <b-form-select v-model="form.ativo" :options="defaultOptions" size="sm" />
                    <small v-if="!$v.form.ativo.minValue" >O valor do campo é inválido.</small>
                </b-form-group>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-4">
                <b-form-group
                    label="Visivel para os Garçons"
                >
                    <b-form-select v-model="form.vandroid" :options="defaultOptions" size="sm" />
                    <small v-if="!$v.form.vandroid.minValue" >O valor do campo é inválido.</small>
                </b-form-group>
            </div>
            <div class="col-md-4">
                <b-form-group
                    label="Visivel para os clientes"
                >
                    <b-form-select v-model="form.vweb" :options="defaultOptions" size="sm" />
                    <small v-if="!$v.form.vweb.minValue" >O valor do campo é inválido.</small>
                </b-form-group>
            </div>
            <div class="col-md-4">
                <b-form-group
                    label="Visivel para as estações"
                >
                    <b-form-select v-model="form.vpc" :options="defaultOptions" size="sm" />
                    <small v-if="!$v.form.vpc.minValue" >O valor do campo é inválido.</small>
                </b-form-group>
            </div>
        </div>
    </jt-form>
</template>
<script>
    import jtForm from '@/components/form.vue'
    import { 
        required, 
        numeric, 
        minValue,
        maxValue,
        minLength,
        maxLength
    } from 'vuelidate/lib/validators'
    export default {
        name: 'novoGrupoView',
        components: {
            jtForm
        },

        data(){
            return {
                form: {
                    descricao: null,
                    ativo: null,
                    vpc: null,
                    vweb: null,
                    vandroid: null
                },

                alert: {
                    type: 'alert-warning',
                    message: '',
                    show: false
                },

                defaultOptions: [
                    { value: null, text: "Selecione uma opção" },
                    { value: 'S', text: "Sim" },
                    { value: 'N', text: "Não" },
                ]
            }
        },

        validations: {
            form: {
                descricao: {
                    required,
                    minLength: minLength(8)
                },

                ativo: {
                    numeric,
                    minValue: minValue(1)
                },

                vweb: {
                    numeric,
                    minValue: minValue(1)
                },

                vpc: {
                    numeric,
                    minValue: minValue(1)
                },

                vandroid: {
                    numeric,
                    minValue: minValue(1)
                }
            }
        },

        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },

        methods: {
            create: function(){
                let formErrors  = this.$v.form.$invalid

                if(formErrors === false){
                    let formBody = []

                    for (let prop in this.form) {
                        if(this.form[prop] !== null){
                            let encodedKey = encodeURIComponent(prop)
                            var encodedValue = encodeURIComponent(this.form[prop])
                            formBody.push(encodedKey + "=" + encodedValue)
                        }
                    }

                    formBody = formBody.join("&")

                    fetch(server + 'crud/grupo/novo', {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'token' : this.getToken
                        }),
                        body: formBody
                    })
                        .then(res => (res.json()))
                        .then(response => {
                            if(response.data){
                                this.alert = {
                                    type: 'success',
                                    message: 'Grupo cadastrado',
                                    show: true
                                }
                            }else{
                                this.alert = {
                                    type: 'warning',
                                    message: response.message,
                                    show: true
                                }
                            }
                        })
                        .catch(error => {
                            this.alert = {
                                type: 'danger',
                                message: 'Erro ao cadastrar',
                                show: true
                            }
                        })
                }else{
                    this.alert = {
                        type: 'warning',
                        message: 'Existem campos inválidos',
                        show: true
                    }
                }
            },
            closeAlert: function(){
                this.alert = {
                    type: 'alert-warning',
                    message: '',
                    show: false
                }
            },

            clear: function(){
                for(let prop in this.form){
                    this.form[prop] = null
                }
            }
        }
    }
</script>